var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "80182eff-9da0-4fc5-bffd-310d0556d562"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "4ea146a4-a76d-49f0-8718-b86ebcd08ec1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "596e5afd-780f-4f30-ad7e-bf0d23adbd03"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-480, 477.69)",
    d: "M 292.309 -140.001 Q 262.386 -140.001 241.19400000000002 -161.19400000000002 Q 220.001 -182.38600000000002 220.001 -212.30900000000003 L 220.001 -720 L 180.001 -720 L 180.001 -779.999 L 360 -779.999 L 360 -815.383 L 600 -815.383 L 600 -779.999 L 779.999 -779.999 L 779.999 -720 L 739.999 -720 L 739.999 -212.30900000000003 Q 739.999 -182.00100000000003 718.999 -161.00100000000003 Q 697.999 -140.00100000000003 667.691 -140.00100000000003 L 292.309 -140.00100000000003 Z M 680 -720 L 280 -720 L 280 -212.30900000000003 Q 280 -206.92400000000004 283.462 -203.46200000000002 Q 286.924 -200.00000000000003 292.30899999999997 -200.00000000000003 L 667.691 -200.00000000000003 Q 672.307 -200.00000000000003 676.154 -203.84600000000003 Q 680 -207.69300000000004 680 -212.30900000000003 L 680 -720 Z M 376.155 -280 L 436.154 -280 L 436.154 -640 L 376.155 -640 L 376.155 -280 Z M 523.846 -280 L 583.845 -280 L 583.845 -640 L 523.846 -640 L 523.846 -280 Z M 280 -720 L 280 -200 L 280 -720 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.63 0.53 -8.46 10.18 540 540)",
    id: "d6172c7e-964e-4b8d-a8ad-d2ea02636251"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -37.167,
    y: -37.167,
    rx: 0,
    ry: 0,
    width: 74.334,
    height: 74.334
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.db524f8b2c12818f8618a93111a3cb7e.svg";
export { ForwardRef as ReactComponent };